var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCemera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.52316 2.625H8.47736C7.94141 2.625 7.67343 2.625 7.43311 2.709C7.28635 2.76029 7.14846 2.83409 7.02437 2.92775C6.82116 3.08112 6.67252 3.30408 6.37524 3.75C6.22299 3.97839 5.99856 4.31503 5.90911 4.40903C5.68746 4.64195 5.39683 4.7975 5.08008 4.85272C4.95224 4.875 4.815 4.875 4.54051 4.875C3.80545 4.875 3.43793 4.875 3.13741 4.96007C2.38566 5.17287 1.79811 5.76041 1.58531 6.51217C1.50024 6.81268 1.50024 7.18021 1.50024 7.91528V10.875C1.50024 12.9963 1.50024 14.0569 2.15925 14.716C2.81826 15.375 3.87893 15.375 6.00024 15.375H12.0003C14.1216 15.375 15.1822 15.375 15.8412 14.716C16.5003 14.0569 16.5003 12.9963 16.5003 10.875V7.91528C16.5003 7.18021 16.5003 6.81268 16.4152 6.51217C16.2024 5.76041 15.6148 5.17287 14.8631 4.96007C14.5626 4.875 14.1951 4.875 13.46 4.875C13.1855 4.875 13.0482 4.875 12.9204 4.85272C12.6036 4.7975 12.313 4.64195 12.0914 4.40903C12.0019 4.31502 11.7775 3.97838 11.6253 3.75C11.328 3.30408 11.1793 3.08112 10.9761 2.92775C10.852 2.83409 10.7142 2.76029 10.5674 2.709C10.3271 2.625 10.0591 2.625 9.52316 2.625Z",
    stroke: "#4F46E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 9.75C12.0003 11.4068 10.6571 12.75 9.00026 12.75C7.34339 12.75 6.00024 11.4068 6.00024 9.75C6.00024 8.09317 7.34339 6.75 9.00026 6.75C10.6571 6.75 12.0003 8.09317 12.0003 9.75Z",
    stroke: "#4F46E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2502 7.125V7.1325",
    stroke: "#4F46E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCemera);
export default __webpack_public_path__ + "static/media/cemera.7927f73fb1be134853b37e524bf98e31.svg";
export { ForwardRef as ReactComponent };